import React, { useEffect, useContext } from 'react'
import { Navigate } from 'react-router-dom'

import { AuthenticationContext } from '../../Auth/authentication.context'
import { useBranding } from '../../contexts/BrandingContext'

const Logout = () => {
  const { onLogout } = useContext(AuthenticationContext)
  const { isGroupMode } = useBranding()

  useEffect(() => {
    onLogout()
  }, [onLogout])

  return <Navigate to={isGroupMode ? '/login' : '/'} replace />
}

export default Logout
